import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { translate } from 'react-i18next'

import { Roles } from '../../config'
import { addUser } from '../../actions'

import { Form, Input, Button, Select, Icon } from 'antd'
const FormItem = Form.Item
const Option = Select.Option

class AppSettingsAddUser extends Component {
  state = {
    // helpers for Projects, Companies multiselect fields
    userProjects: null,
    userCompanies: null
  }

  handleProjectsChange = values => {
    this.setState({ userProjects: [...values] })
  }

  handleCompaniesChange = values => {
    this.setState({ userCompanies: [...values] })
  }

  handleSubmit = e => {
    e.preventDefault()
    const { form, user, addUser } = this.props

    form.validateFields((err, values) => {
      if (!err) {
        // pass custom resetFormFields() so we can clear the form in redux on success
        addUser(values, user.idToken, this.resetFormFields)
      } else {
        console.log(err)
      }
    })
  }

  resetFormFields = () => {
    const { form } = this.props

    form.resetFields()
    this.setState({ userProjects: null, userCompanies: null })
  }

  render () {
    const { form: { getFieldDecorator }, projects, loading, user, companies, t } = this.props
    const { userProjects, userCompanies } = this.state

    // filter user's Projects roles based on selected Companies,
    // so then we can see only Projects that belong to selected Companies
    const filteredProjectRoles =
      userCompanies &&
      _.pickBy(user.projectsRoles, (projectRole, projectId) => userCompanies.includes(projects[projectId].companyId))

    // user Companies select helpers
    const companiesOptions = []
    _.map(companies, (role, companyId) =>
      companiesOptions.push(
        <Option key={companyId} value={companyId}>
          {companies[companyId].name}
        </Option>
      )
    )
    const companyRolesOptions = []
    _.map(Roles.COMPANY, (role, roleKey) =>
      companyRolesOptions.push(
        <Option key={role} value={role}>
          {t(`roles.${roleKey}`)}
        </Option>
      )
    )

    // Projects select helpers - TODO: do this in FB rules
    const projectsThatIAmAdminIn = _.pickBy(filteredProjectRoles, role => role <= Roles.PROJECT.MANAGER)
    const projectsOptions = []
    _.map(projectsThatIAmAdminIn, (role, projectId) =>
      projectsOptions.push(
        <Option key={projectId} value={projectId}>
          {projects[projectId].name}
        </Option>
      )
    )
    const projectsRolesOptions = []
    _.map(Roles.PROJECT, (role, roleKey) =>
      projectsRolesOptions.push(
        <Option key={role} value={role}>
          {t(`roles.${roleKey}`)}
        </Option>
      )
    )

    const roleFormItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 6 }
    }

    return (
      <Form onSubmit={this.handleSubmit}>

        <FormItem label='E-mail'>
          {getFieldDecorator('email', {
            rules: [{ type: 'email' }, { required: true }]
          })(<Input prefix={<Icon type='mail' style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder='User email' />)}
        </FormItem>

        <FormItem label='Name'>
          {getFieldDecorator('name', {
            rules: [{ required: true, message: 'Please input your name!' }]
          })(<Input prefix={<Icon type='user' style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder='User name' />)}
        </FormItem>

        {/* USER COMPANIES - Show only to superadmin, admin can only add to his own company */}
        <FormItem label='Companies'>
          {getFieldDecorator('companyIds', {
            rules: [{ required: true, message: 'Please select at least one Company' }]
          })(
            <Select mode='multiple' placeholder='Companies' onChange={this.handleCompaniesChange}>
              {companiesOptions}
            </Select>
          )}
        </FormItem>

        {userCompanies &&
          userCompanies.map(companyId => (
            <FormItem label={companies[companyId].name} {...roleFormItemLayout} key={companyId}>
              {getFieldDecorator(`companies.${companyId}`, {
                initialValue: 20 // 'USER'
              })(
                <Select placeholder='Company role'>
                  {companyRolesOptions}
                </Select>
              )}
            </FormItem>
          ))}

        {/* USER PROJECTS */}
        <FormItem label='Projects'>
          {getFieldDecorator('projectIds' /* { rules: [{ required: true }] } */)(
            <Select mode='multiple' placeholder='Projects' onChange={this.handleProjectsChange}>
              {projectsOptions}
            </Select>
          )}
        </FormItem>

        {userProjects &&
          userProjects.map(projectId => (
            <FormItem label={projects[projectId].name} {...roleFormItemLayout} key={projectId}>
              {getFieldDecorator(`projects.${projectId}`, {
                initialValue: 30 // 'CLIENT'
              })(
                <Select placeholder='Project role'>
                  {projectsRolesOptions}
                </Select>
              )}
            </FormItem>
          ))}

        <Button type='primary' htmlType='submit' loading={loading.addUser}>Add user</Button>

      </Form>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  projects: state.projects,
  user: state.user,
  loading: state.loading,
  companies: state.companies
})

const mapDispatchToProps = {
  addUser
}

export default connect(mapStateToProps, mapDispatchToProps)(
  Form.create()(translate('translations')(AppSettingsAddUser))
)



// WEBPACK FOOTER //
// ./src/components/AppSettings/AppSettingsAddUser.js